import React from 'react'

const Contact = () => {
    return (
        <div className="page">
            <h1 className="page-title">
                contact us
            </h1>
        </div>
    )
}

export default Contact
